import { useEffect, useLayoutEffect, useState, RefObject } from 'react';

export const useTabsIndicatorCalculations = (
  wrapperRef: RefObject<HTMLDivElement>, activeTabRef: RefObject<HTMLDivElement> | null, isVertical: boolean
) => {
  const [indicatorPosition, setIndicatorPosition] = useState(0);
  const [indicatorSize, setIndicatorSize] = useState(0);

  const updateCalculations = () => {
    if (activeTabRef?.current && wrapperRef?.current) {
      const activeTabBoundingRect = activeTabRef.current.getBoundingClientRect();
      const wrapperBoundingRect = wrapperRef.current.getBoundingClientRect();

      if (isVertical) {
        setIndicatorPosition(Math.round(activeTabBoundingRect.top - wrapperBoundingRect.top) + wrapperRef.current.scrollTop);
        setIndicatorSize(activeTabRef.current.offsetHeight);
      } else {
        setIndicatorPosition(Math.round(activeTabBoundingRect.left - wrapperBoundingRect.left) + wrapperRef.current.scrollLeft);
        setIndicatorSize(activeTabRef.current.offsetWidth);
      }
    }
  };

  // TODO: extract as versatile hook shared across multiple packages
  useEffect(() => {
    const observer = new ResizeObserver(updateCalculations);

    if (activeTabRef?.current) {
      observer.observe(activeTabRef.current);
    }

    if (wrapperRef?.current) {
      observer.observe(wrapperRef.current);
    }

    return () => observer.disconnect();
  });

  useLayoutEffect(() => {
    updateCalculations();
  });

  return { indicatorPosition, indicatorSize };
};
